module.exports = __webpack_public_path__ + "static/media/sword.f3ba3bf4.mp3";